import { render, staticRenderFns } from "./FeaturedWorks.vue?vue&type=template&id=fc77d534&scoped=true&"
import script from "./FeaturedWorks.vue?vue&type=script&lang=js&"
export * from "./FeaturedWorks.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedWorks.vue?vue&type=style&index=0&id=fc77d534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc77d534",
  null
  
)

export default component.exports